"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Model_1 = __importDefault(require("../Model"));
var array_1 = require("../../helpers/array");
var EssayReplyModel = /** @class */ (function (_super) {
    __extends(EssayReplyModel, _super);
    function EssayReplyModel(essayReply, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = essayReply.id;
        _this.status = essayReply.status;
        _this.position = essayReply.position;
        _this.updatedAt = new Date(essayReply.updatedAt);
        _this.questionId = essayReply.questionByQuestionId || essayReply.questionId;
        return _this;
    }
    EssayReplyModel.prototype.subject = function () {
        return this.getters.subjectById(this.questionId);
    };
    Object.defineProperty(EssayReplyModel.prototype, "contents", {
        get: function () {
            return this.getters
                .contentsByEssayReplyId(this.id)
                .concat()
                .sort(array_1.positionAscending);
        },
        enumerable: true,
        configurable: true
    });
    EssayReplyModel.prototype.link = function () {
        var subject = this.subject();
        if (subject.link) {
            if (this.status === 'DRAFT') {
                // return `${this.subject().link()}/${this.position+1}`
                return this.subject().link();
            }
            // return `${this.subject().link()}/${this.position+1}/correcao`
            return this.subject().link() + "/correcao";
        }
        return '/';
    };
    EssayReplyModel.prototype.imageAnswer = function () {
        var imageContent = this.contents().find(function (content) { return !!content.imageId; });
        if (imageContent) {
            return imageContent.image();
        }
        return {};
    };
    EssayReplyModel.prototype.textAnswer = function () {
        var textContent = this.contents().find(function (content) { return !!content.textId; });
        if (textContent) {
            return textContent.text();
        }
        return { body: '' };
    };
    EssayReplyModel.prototype.completed = function () {
        if (this.status === 'DRAFT') {
            // completed should never be more than 99% if essay is still a draft
            // 2840 is the average length of a perfect essay
            // 2300 is minimum length of a perfect essay
            // todo: a better metric than character length should be used
            return Math.min(99, Math.round((100 * this.textAnswer().body.length) / 2300));
        }
        return 100;
    };
    EssayReplyModel.prototype.corrections = function () {
        return this.getters.correctionsByEssayReplyId(this.id);
    };
    EssayReplyModel.prototype.correction = function () {
        return this.corrections()[0];
    };
    EssayReplyModel.__typename = 'EssayReply';
    return EssayReplyModel;
}(Model_1.default));
exports.EssayReplyModel = EssayReplyModel;
